import { createContext, RefObject } from 'react'

export const LayoutEventContext = createContext<Partial<{
  getCoordsEventBanner: (ref: RefObject<HTMLElement>) => void
  isEventBannerScrolled: boolean
}> | null>(null)
